import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';

declare var $: any;

@Component({
    selector: 'app-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit {
    urlBase: any = (<any>params).api.s3;
    @Input('route') public route: string;
    public widgetData: any = null;
    public errors: any = null;
    public loadings: any = true;
    urlBaseMJ: any = (<any>params).api.mj;
    constructor(
        private _homeService: HomeService,
    ) {
        this.getWidgetOptions();
    }

    ngOnInit() {
    }

    ngAfterContentInit(): void {
        //SCRIPT BUTTON
        setTimeout(() => {
            $(function () {

                $(".ripple").on('click', function (e) {

                    if ($(this).find('span').length === 0) {

                        $(this).append('<span></span>');

                        var ripple = $(this).find('span'),
                            size = ($(this).innerWidth() > $(this).innerHeight()) ? $(this).innerWidth() * 2 : $(this).innerHeight() * 2,
                            clickY = $(this).offset().top,
                            clickX = $(this).offset().left,
                            x = e.pageX - clickX,
                            y = e.pageY - clickY;

                        ripple.css({
                            'top': y + 'px',
                            'left': x + 'px',
                        });

                        ripple.animate({
                            'width': size + 'px',
                            'height': size + 'px',
                            'margin-top': -size / 2 + 'px',
                            'margin-left': -size / 2 + 'px',
                            'opacity': 0,
                        }, 600, function () {
                            $(this).remove();
                        });

                    }

                });

            });

        }, 1000);

    }

    getWidgetOptions() {
        this._homeService.getWidgetOptions().subscribe(
            data => {
                this.widgetData = data;
                if (
                    !(
                        data &&
                        data.widget_motor &&
                        data.widget_motor_hoteles &&
                        data.widget_motor_tours &&
                        data.widget_motor_vuelo_hotel &&
                        data.widget_motor_vuelos &&
                        JSON.stringify(data.widget_motor).length > 3 &&
                        JSON.stringify(data.widget_motor_hoteles).length > 3 &&
                        JSON.stringify(data.widget_motor_tours).length > 3 &&
                        JSON.stringify(data.widget_motor_vuelo_hotel).length > 3 &&
                        JSON.stringify(data.widget_motor_vuelos).length > 3
                    )
                ) {
                    console.warn('Sin data widgets');
                    this.loadings = false;
                }
            },
            err => {
                console.error(err);
                this.errors = err;
            }
        );
    }

    reload() {
        this.loadings = true;
        this.getWidgetOptions();
    }
}
